import React, { useState, useEffect } from 'react'
// base components
import { Content, Loader } from "../core/components";
import styled from 'styled-components'
import axios from "axios";
import { resolveAsuHost } from '../core/utils/asuHost';

import DefaultRoute from "../core/components/ErrorPage";

const FadeInContainer = styled.div`
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 300ms ease;
`;

const ASU_HOST = resolveAsuHost();

function TargetedRoute(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isContentLoading, setIsContentLoading] = useState(true);
  const [data,setData] = useState({"site_name":"Faculty Sites","menu":[],"content":[],"redirects":[]});
  const [status, setStatus] = useState();
  const [isCustom, setCustom] = useState( props.custom );
  const [targetGroup, setGroup] = useState( ( isCustom ? props.group : props.match.params.group ) );

  const getData=()=>{
    setIsLoading(true);
    axios({
      method: 'get',
      url: `${ASU_HOST}/clas_group_api/${targetGroup}`,
      withCredentials: false
      })
      .then((response) => {
        // Empty responses from the server are [] instead of {}.
        if ( !Array.isArray(response.data) ) {
          setData(response.data);
          setStatus(response.status);
          setIsContentLoading(true);
          setIsLoading(false);
        }
        //else {
        //  window.location.href = "/";
        //}
      })
      .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.status);
          setStatus(error.response.status);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
          setStatus(500);
        } else {
          // Something happened in setting up the request that triggered an Error
          setStatus(500);
          console.log('Error', error.message);
        }

        setIsLoading(false);

      });
  }

  useEffect( ()=>getData(),[] );
  let targetPage = window.location.pathname;
  if ( !isCustom ) targetPage = targetPage.replace(new RegExp("^/"+targetGroup),"");

  return (
    <div>
    { isLoading === false ?
        <FadeInContainer isVisible={isContentLoading === false}>
          <Content
            status={status}
            data={data}
            group={targetGroup}
            page={targetPage}
            custom={isCustom}
            onContentLoading={setIsContentLoading}
          ></Content>
        </FadeInContainer>
      :
        null
    }
    { isLoading || isContentLoading ? <Loader /> : null }
    {/* Cookie consent widget temporarily disabled until new ASU packages are available */}
    </div>
  );

}


export default TargetedRoute;
